import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import GithubCodeScanCredentialsForm from './GithubCodeScanCredentialsForm';
import GithubCodeScanMappingFormV2 from './GithubCodeScanMappingFormV2';
import { columnRenderArrayData } from 'utils/tableUtils';
import { DELIMITER } from './GithubCodeScanMappingFormV2';
import _ from 'lodash'

const GithubCodeScanConfigListing = (props) =>{

    const columns = useMemo(() => [{
        title: "Repository",
        dataIndex: "repositoryName",
        render: (repositoryName, record) => {
            const { branchName } = record;

            if(_.isEmpty(branchName)) return columnRenderArrayData(repositoryName);

            const branchesList = _.split(branchName, ',');

            return branchesList.map(list => {
                const [repositery, branch] = _.split(list, DELIMITER);
                return <p>{repositery}{branch ? `-[${branch}]`: ''}</p>
            })
        },
        width: 200
    }
    ], []);


    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={GithubCodeScanMappingFormV2}
            CredentialsForm={GithubCodeScanCredentialsForm}
            extraColumns={columns}
        />
    );
} 

export default GithubCodeScanConfigListing;
